import type { RequestOptions } from '@@/plugin-request/request';
import { type RequestConfig } from '@umijs/max';
import qs from 'query-string';
// import { checkAuth } from './services/auth/checkAuth';
// import { trimData } from './utils/formatter';

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (url: string, options: RequestOptions) => {
      const accessToken = localStorage.getItem('ACCESS_TOKEN');

      const refreshToken = localStorage.getItem('REFRESH_TOKEN');

      const isApiRefresh = url.includes('/v1/auth/refresh');

      options.headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        ...(options.headers || {}),
        ...((accessToken || refreshToken) && {
          Authorization: `Bearer ${isApiRefresh ? refreshToken : accessToken}`,
        }),
      };

      return {
        url,
        options,
      };
    },
  ],

  responseInterceptors: [
    [
      async (response) => response,

      async (error: any) => {
        if (error?.response?.status === 401) {
          // if (!checkAuth.decodeToken()) {
          //   return checkAuth.logout();
          // }
          // try {
          //   await checkAuth.fetchRefreshToken();
          //   return request(error.config.url, error.config);
          // } catch (error) {
          //   return checkAuth.logout();
          // }
          // return history.push('/login');
        }

        return Promise.reject(error);
      },
    ],
  ] as RequestConfig['responseInterceptors'],

  timeout: 60000,
  paramsSerializer: (params) => qs.stringify(params),
  baseURL: REACT_APP_BASE_URL,
  transformRequest: (data) => JSON.stringify(data),
};
